import SalarySlabInfo from "./SalarySlabInfo.component";
import SalarySlabForm from "./SalarySlabForm.component";
import { useState } from "react";

const EditSalarySlab = ({ onEdit, _data, }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState(null);
  const handelEdit = (data) => {
    setIsEdit(true);
    setEditData(data);
  };

  const handelEditData = (data) => {
    setIsEdit(false);
    onEdit(data);
  };

  return isEdit ? (
    <SalarySlabForm outputData={handelEditData} ediData={editData} />
  ) : (
    <SalarySlabInfo onEdit={handelEdit} _data={_data} />
  );
};

export default EditSalarySlab;
